import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBack,
  MdArrowForward,
  MdAttachFile,
  MdCancel,
  MdMenu,
  MdMoreHoriz,
  MdOutlineImage,
} from "react-icons/md";

import { useLocation, useNavigate, useParams } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import "../styles/Home.css";

export default function Bottombar({
  mobile,
  companyData,
  authToken,
  isSeller,
  setIsSeller,
  setScrollPositionSeller,
  setScrollPositionHome,
}) {
  let location = useLocation().pathname;
  let navigate = useNavigate();

  const [isACreator, setisACreator] = useState(false);

  const handleNavigateClick = (destination, source) => {
    if (location == "/") {
      setScrollPositionHome(window.scrollY);
    }
    if (location == "/seller") {
      setScrollPositionSeller(window.scrollY);
    }
    window.scrollTo(0, 0);

    navigate(destination);
  };

  if (location != "/seller" && (location != "/") & (location != "/orders")) {
    return <div></div>;
  }

  return (
    <div
      className={
        location != "/seller" && (location != "/") & (location != "/orders")
          ? "d-none"
          : "home_bottombar"
      }>
      <div
        id={"bottom_nav_left"}
        className={
          isSeller ? "home_bottombar_nav_leftSeller" : "home_bottombar_nav_left"
        }
        onClick={() => location != "/" && handleNavigateClick("/")}>
        {location == "/" ? <div className="active_nav">Suchen</div> : "Suchen"}
      </div>
      <div
        id={"bottom_nav_middle"}
        className={
          isSeller
            ? "home_bottombar_nav_middleSeller"
            : "home_bottombar_nav_middle"
        }
        onClick={() => location != "/orders" && handleNavigateClick("/orders")}>
        {location == "/orders" ? (
          <div className="active_nav">Bestellungen</div>
        ) : (
          "Bestellungen"
        )}
      </div>
      {isSeller && (
        <div
          className="home_bottombar_nav_rightSeller"
          onClick={() =>
            location != "/seller" && handleNavigateClick("/seller")
          }>
          {location == "/seller" ? (
            <div className="active_nav">Stories</div>
          ) : (
            "Stories"
          )}
        </div>
      )}
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 33px;
  color: #575757;
`;

const ArrowBack = styled(MdArrowBack)`
  font-size: 20px;
  color: #636363;
  margin-top: 2px;
`;

const MoreIcon = styled(MdMoreHoriz)`
  font-size: 20px;
  color: #474747;
`;

const ImageIcon = styled(MdOutlineImage)`
  font-size: 30px;
  color: #474747;
`;

const SendIcon = styled(MdArrowForward)`
  font-size: 20px;
  color: #ffffff;
  transform: rotate(-90deg);
`;

const FileIcon = styled(MdAttachFile)`
  font-size: 20px;
  color: #474747;
`;

const CancelIcon = styled(MdCancel)`
  font-size: 25px;
  color: #575757;
`;
